up.compiler('[data-reveal]', (element: HTMLElement) => {
  const target = document.querySelector(element.getAttribute('data-reveal')!)

  if (target) {
    setTimeout(() => {
      up.reveal(target, { top: true })
    }, 100)
  }
})
